import { Flex, Text } from '@spotify-internal/encore-web';
import { ObservationsV1IssueAutonomyLevel } from '@spotify/confidence-graphql';

import {
  AUTONOMY_LEVEL_OPTIONS,
  getAutonomyLevelDescription,
  getAutonomyLevelLabel,
} from '../../types';

import styles from './IssueAutonomyLevelPopoverContent.module.css';

export type IssueAutonomyLevelPopoverContentProps = {
  value?: ObservationsV1IssueAutonomyLevel | null;
  disabled?: boolean;
  onChange: (level: ObservationsV1IssueAutonomyLevel) => void;
  onSelected?: () => void;
};

export const IssueAutonomyLevelPopoverContent = ({
  value,
  disabled = false,
  onChange,
  onSelected,
}: IssueAutonomyLevelPopoverContentProps) => {
  return (
    <div className={styles.content}>
      <Text
        as="p"
        variant="bodySmall"
        semanticColor="textSubdued"
        className={styles.intro}
      >
        Choose what Confidence can do on this issue before it needs your
        approval.
      </Text>
      <div
        role="radiogroup"
        aria-label="Change autonomy"
        className={styles.optionList}
      >
        {AUTONOMY_LEVEL_OPTIONS.map(level => {
          const label = getAutonomyLevelLabel(level);

          return (
            <button
              key={level}
              type="button"
              role="radio"
              aria-checked={value === level}
              aria-label={label}
              disabled={disabled}
              className={styles.option}
              data-selected={value === level}
              onClick={() => {
                onChange(level);
                onSelected?.();
              }}
             data-track-source-anchor="dc82231960;issue-autonomy-level-popover-content-button">
              <Flex
                direction="column"
                gap="tighter-4"
                className={styles.optionText}
              >
                <Text as="span" variant="bodySmallBold">
                  {label}
                </Text>
                <Text as="span" variant="bodySmall" semanticColor="textSubdued">
                  {getAutonomyLevelDescription(level)}
                </Text>
              </Flex>
            </button>
          );
        })}
      </div>
    </div>
  );
};
